/* @flow */

import {Observable} from 'rxjs';
import type {ActionsObservable} from 'redux-observable';
import {switchMap, debounceTime, map, catchError} from 'rxjs/operators';

import {checkCoupon} from './billing-api';
import {
    ActionTypes,
    resolveCheckCoupon,
    failCheckCoupon,
    type BillingAction,
    type CheckCouponRequestAction,
} from './billing-actions';

export const CheckCouponEpic = (action$: ActionsObservable<BillingAction>) =>
    action$.ofType(ActionTypes.BILLING_CHECK_COUPON_REQUEST).pipe(
        debounceTime(200),
        switchMap((action: CheckCouponRequestAction) => {
            const couponCode = action.payload;

            return Observable.from(checkCoupon(couponCode)).pipe(
                map((response) => resolveCheckCoupon(response.coupon)),
                catchError(() => Observable.of(failCheckCoupon()))
            );
        })
    );
